<div class="overlay-modal">
    <div class="modal-container">
        <div class="modal-container-header">
            <ng-content select="[modal-title]"></ng-content>
            <span class="k-icon k-i-close-circle" *ngIf="closable" (click)="close()"></span>
        </div>
        <div class="modal-container-section content-scroll">
            <ng-content select="[modal-content]"></ng-content>
        </div>
    </div>
</div>
